import React, {Component} from 'react'
import RelationshipEditForm from "./form/edit.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class RelationshipEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            product: {},
            productTitle: ''
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        const relationshipId = this.props.match.params.relationshipId
        AppContext.getApiClient().get('/relationships/' + relationshipId).then((relationship) => {

            const relationshipForm = <RelationshipEditForm relationship={relationship} />
            this.setState({
                relationshipDescription: relationship.attributes.description,
                relationshipForm: relationshipForm
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.relationshipForm}
            </div>
        );
    }
}

export default RelationshipEdit


// WEBPACK FOOTER //
// ./src/relationship/edit.component.jsx